export default function PasswordSwitcher() {

  const passwordFields = document.querySelectorAll('[type="password"]');

  [...passwordFields].forEach(el => {

    const icon = el.parentNode.querySelector('.TextField-switchPassword');
    if (!icon) return null;

    icon.addEventListener('click', (e) => {
      e.preventDefault();

      icon.classList.toggle('is-noVisible');
      el.setAttribute("type", el.getAttribute('type') === "password" ? "text" : "password");

    })
  })
}
